import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BrandMark from '../../components/BrandMark';
import { useNavigate } from 'react-router-dom';
import { UNATHORIZED } from '../../common/constants/routes.constants';
import { useUserStore } from '../../store/useUserStore';
import { getUserAdministrationInfo } from '../../api/auth.api';

import { palette } from '../../theme';
const CallbackPage: React.FC = () => {
  const { t } = useTranslation();
  const { isLoading, user } = useAuth0();
  const navigate = useNavigate();
  const { setUserInfo } = useUserStore();

  useEffect(() => {
    if (!isLoading && user) {
      checkUserRole();
    }
  }, [isLoading, user]);

  const checkUserRole = async () => {
    try {
      const response = await getUserAdministrationInfo();

      const { isAdmin, isKindergartenAdmin, isSuperAdmin } = response;
      const isAuthorized = isAdmin || isKindergartenAdmin || isSuperAdmin;
      setUserInfo(response);
      navigate(isAuthorized ? '/' : UNATHORIZED);
    } catch (err) {
      navigate(UNATHORIZED);
    }
  };

  // what someone sees while Auth0 hands them back: the brand, and that something is happening
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        height: '100%',
        minHeight: '100vh',
        backgroundColor: palette.surface.tint
      }}
    >
      <BrandMark width={81} height={96} />
      <LinearProgress
        aria-label={t('auth.signingIn')}
        sx={{
          width: 120,
          borderRadius: 9999,
          backgroundColor: palette.lavender.soft,
          '& .MuiLinearProgress-bar': { backgroundColor: palette.primary.main, borderRadius: 9999 }
        }}
      />
      <Typography sx={{ fontSize: 14, color: palette.text.secondary }}>{t('auth.signingIn')}</Typography>
    </Box>
  );
};

export default CallbackPage;
